<div mat-dialog-title>
  <div class="text-truncate title dialog-title" i18n>Материалы</div>
  <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="no-padding" fusePerfectScrollbar>
  <ng-container *ngIf="data$ | async as data">
    <div *ngIf="data.result" class="flex flex-col items-stretch">
      <mat-form-field appearance="outline" class="p-4 no-subscript">
        <mat-label i18n>Материал</mat-label>
        <mat-select [value]="data.result[0]" #materialSelect>
          <mat-option *ngFor="let item of data.result" [value]="item">
            {{ item.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-divider></mat-divider>

      <csl-panel-list
        #panelList
        [orderId]="0"
        class="panel-list flex flex-col basis-[48vh]"
        *ngIf="materialSelect.value && settings$ | async as cuttingSettings"
        [presetSettings]="presetSettings"
        [inMatBaseIdMaterial]="materialSelect.value.inMaterialBaseId"
        [userId]="userId"
        [panels]="materialSelect.value.panels"
        [mainMaterial]="materialSelect.value"
        [materialWidth]="materialSelect.value.width"
        [cuttingSettings]="cuttingSettings"></csl-panel-list>
    </div>

    <div class="p-4" *ngIf="!data.result && !data.error">Loading…</div>

    <div class="p-4" *ngIf="data.error">
      <csl-no-data-display></csl-no-data-display>
    </div>
  </ng-container>
</div>
<div *ngIf="materials?.length > 0" mat-dialog-actions>
  <button i18n mat-button (click)="copyMaterialsInOrder()">СКОПИРОВАТЬ МАТЕРИАЛЫ</button>
</div>
